export default {
    ADD_ALERT(state, newValue) {
        state.alerts.push(newValue)
    },
    CLEAR_ALERTS(state) {
        state.alerts = []
    },
}